/* eslint-disable no-unused-vars */
import { useState } from 'react';
import { Buttons } from 'components';
import { SearchSection } from './SearchSection';
import { SelectedAppsSection } from './SelectedAppsSection';
import { SearchList } from './SearchList';
import { useSignal } from '@preact/signals-react';

export const ChooseAppSection = ({ onChange, value }) => {
  const showSelectedApps$ = useSignal(Boolean(value.length));
  const searchValue$ = useSignal('');
  const deleteSelectedAdd = (pba_id) => {
    const newList = value.filter((app) => app.pba_id !== pba_id);
    onChange(newList);
  };

  const onClearAll = () => {
    onChange([]);
  };

  return (
    <div
      className='ChooseAppSection'
      style={{
        height: '100%',
        flexGrow: 1,
        overflow: 'hidden',
      }}
    >
      <SearchSection
        selectedApps={value}
        onChange={onChange}
        showSelectedApps$={showSelectedApps$}
        searchValue$={searchValue$}
      />

      {showSelectedApps$.value ? (
        value?.length ? (
          <SelectedAppsSection value={value} onDelete={deleteSelectedAdd} onClearAll={onClearAll} />
        ) : null
      ) : (
        <SearchList selectedApps={value} onChange={onChange} searchValue$={searchValue$} />
      )}
    </div>
  );
};
